import LocationPageTemplate from '@/components/locations/LocationPageTemplate';

const NewburyParkPage = () => (
  <LocationPageTemplate
    city="Newbury Park"
    path="/newbury-park"
    postalCode="91320"
    latitude={34.1845}
    longitude={-118.9104}
    metaTitle="Pressure Washing & Cleaning Services in Newbury Park, CA | Ventura Power Washing"
    metaDescription="Hot-water pressure washing, soft wash, window, gutter, and solar panel cleaning in Newbury Park, CA, including Dos Vientos and Lynn Ranch. Call (805) 464-7166 for a free estimate."
    keywords="pressure washing Newbury Park, power washing Dos Vientos, soft wash Lynn Ranch, window cleaning Newbury Park CA, exterior cleaning 91320"
    schemaDescription="Pressure washing, soft wash, window, gutter, solar panel, and carpet cleaning in Newbury Park, CA, including Dos Vientos and Lynn Ranch."
    heroText="Hot-water pressure washing and gentle soft washing for Newbury Park homes and HOAs, from Dos Vientos to Lynn Ranch. Insured, locally owned, and no long-term contracts."
    localHeading="What Makes Newbury Park Properties Unique to Clean?"
    localText="Newbury Park sits in the Conejo Valley, where many homes are stucco, many streets are lined with mature trees, and many communities are managed by HOAs. We clean driveways, walkways, common areas, roofs, windows, and solar panels for homeowners and property managers throughout Newbury Park."
    neighborhoods={['Dos Vientos', 'Lynn Ranch']}
    localFactors={[
      'Stucco exteriors are common, so we soft wash instead of blasting them with high pressure.',
      'Tree-lined streets mean leaf litter in gutters and on roofs and driveways.',
      'HOA communities often need consistent, scheduled cleaning of common areas and walkways.',
    ]}
    faqs={[
      {
        question: 'How much does pressure washing cost in Newbury Park, CA?',
        answer: 'Most driveway, patio, and walkway pressure washing jobs in Newbury Park run $150-$400, depending on square footage and surface type. We provide a free estimate before any work begins.',
      },
      {
        question: 'Do you serve Dos Vientos and Lynn Ranch?',
        answer: 'Yes. We regularly serve homeowners and HOAs in Dos Vientos, Lynn Ranch, and the rest of Newbury Park.',
      },
      {
        question: 'Is it safe to clean stucco homes in Newbury Park?',
        answer: 'Yes, when the right method is used. We soft wash stucco at low pressure with biodegradable, plant-safe detergents and never use high pressure on stucco.',
      },
      {
        question: 'How much does solar panel cleaning cost in Newbury Park?',
        answer: 'Solar panel cleaning in Newbury Park typically costs $150-$350 depending on the number of panels and roof access.',
      },
    ]}
  />
);

export default NewburyParkPage;
